import {Model} from '@/models/Model';

export class HrAnswer extends Model {
    modelUri = 'hr-answer';
    fields = ['question_id', 'name', 'correct'];
}